import axios from 'axios';

interface PollJobOptions {
  maxAttempts?: number;
  delay?: number;
}

interface PollJobResult {
  promise: Promise<any>;
  cancel: () => void;
}

export function poll(url: string, options: PollJobOptions = {}): PollJobResult {
  const { maxAttempts = 10, delay = 3000 } = options;
  let attempts = 0;
  let intervalId: ReturnType<typeof setInterval> | null = null;
  let isCancelled = false;

  const promise = new Promise((resolve, reject) => {
    intervalId = setInterval(async () => {
      if (isCancelled) {
        clearInterval(intervalId!);
        reject(new Error(`Job ${url} polling cancelled`));
        return;
      }

      attempts++;

      try {
        const response = await axios.get(url, {
          getAccessToken: true,
          timeout: 120000,
        } as any);

        const job = response.data;

        if (job.status !== 1 && job.status !== 2) {
          clearInterval(intervalId!);
          resolve(job);
        } else if (attempts >= maxAttempts) {
          clearInterval(intervalId!);
          reject(
            new Error(
              `Job ${url} polling exceeded maximum attempts (${maxAttempts})`,
            ),
          );
        }
      } catch (error) {
        clearInterval(intervalId!);
        reject(error);
      }
    }, delay);
  });

  const cancel = () => {
    isCancelled = true;
    if (intervalId) {
      clearInterval(intervalId);
    }
  };

  return { promise, cancel };
}
